<ng-template #modalSession1 let-modal>
    <div class="modal-header border-bottom-0 p-0 bot_spa_aft_sect_heading">
        <span class="sectionHeading_one" *ngIf="!issessionExpired" id="exampleModalLabel">
            {{'popupMessages.sessiontitle' | translate}}</span>
        <span class="sectionHeading_one" *ngIf="issessionExpired" id="exampleModalLabel">
            {{'popupMessages.sessionExpTitle' | translate}}</span>
        <ng-container *ngIf="!issessionExpired">
            <button type="button" id="clsTooltipa" (click)="modal.close()" aria-label="Close" class="infoButton"
                data-toggle="tooltip">
                <span class="sectionHeading_one" aria-hidden="true">&times;</span>
                <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
            </button>
        </ng-container>
    </div>
    <div class="modal-body p-0">
        <div class="row no-gutters bot_spa_aft_sect_heading">
            <div class="col-12">
                <ng-container *ngIf="issessionExpired">
                    <ng-container *ngIf="flowType?.type==prequalType">
                        {{'popupMessages.sessionExpiredMsg' | translate}} {{'popupMessages.sessionExpiredMsgSecondLine'
                        |
                        translate}}
                        <span>{{'popupMessages.newAppLink' |
                            translate}}</span>
                    </ng-container>
                    <ng-container *ngIf="flowType?.type==switchType">
                        {{'popupMessages.sessionExpiredMsg' | translate}}
                        {{'popupMessages.sessionExpiredMsgSecondLineSwitch' |
                        translate}}
                        <span>{{'popupMessages.newAppLink' |
                            translate}}</span>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!issessionExpired">
                    <div [innerHTML]="'popupMessages.sessionpopup' | translate"></div>
                </ng-container>
            </div>
        </div>
        <div class="row no-gutters">
            <div *ngIf="!issessionExpired" class="col-md-6 col-12 order-md-1 order-2 bot_spa_aft_mobile_sec_heading pr-md-2">
                <button type="button"  class="common_btn cancelBtn_features popUpCancel w-100"
                    data-dismiss="modal" (click)="dismissModal();modal.close()">{{'popupMessages.leave' |
                    translate}}</button>
            </div>
            <div *ngIf="issessionExpired" [ngClass]="currentLang=='fr'?'col-12 order-2 bot_spa_aft_sect_heading':'col-md-6 col-12 order-md-1 order-2 bot_spa_aft_mobile_sec_heading pr-md-2'">
                <button type="button"  class="common_btn cancelBtn_features popUpCancel w-100"
                    data-dismiss="modal" (click)="dismissModal();modal.close()">{{'popupMessages.cancelBtn' |
                    translate}}</button>
            </div>
            <div *ngIf="!issessionExpired"
                class="col-md-6 col-12 order-1 bot_spa_aft_mobile_sec_heading order-md-2 pl-md-2">
                <button type="button" class="common_btn saveNextBtn_features w-100"
                    (click)="resetTimer();modal.close()">{{'popupMessages.sessiontitleyes' |
                    translate}} </button>
            </div>
            <div *ngIf="issessionExpired"
                [ngClass]="currentLang=='fr'?'col-12 order-1 bot_spa_aft_sect_heading':'col-md-6 col-12 order-1 bot_spa_aft_mobile_sec_heading order-md-2 pl-md-2'">
                <button type="button" class="common_btn saveNextBtn_features w-100"
                    (click)="clearSession();modal.close()">{{'popupMessages.newAppLinkBtn' |
                    translate}} </button>
            </div>
        </div>
    </div>
</ng-template>
<div class="modal fade" id="referralPopup" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" appTrapFocusDirective>
            <div class="modal-header border-0">
                <span class="sectionHeading_two" role="heading"
                    aria-level="2">{{'popupMessages.referralHeader'|translate}}</span>
                <button type="button" class="close" aria-label="Close" (click)="closePopup()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="container-fluid p-0">
                    <ng-container *ngIf="!referral">
                        <div class="bot_spa_aft_sect_heading">
                            <span>
                                {{'popupMessages.genericNo'|translate}}
                            </span>
                            <span>
                                <a href="tel:1-888-264-6843" tabindex="0">
                                    <span class="note_link"><u>{{'header.contactNo' |translate}}</u></span>
                                    <span class="show-for-sr">{{'header.txtPhn' |translate}}</span>
                                </a>
                            </span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="referral">
                        <ng-container *ngIf="!maObjPresent">
                            <p>{{'popupMessages.referralBody1'|translate}}</p>
                            <span>{{'popupMessages.referralBody3'|translate}}
                                <a [href]="referralLink" target="_blank" class="note_link"
                                    (click)="closeGeneric()"><u>{{'popupMessages.referralBody4'|translate}}</u></a>
                                <ng-container *ngIf="flowType?.type==prequalType">
                                    {{'popupMessages.referralBody5'|translate}}
                                </ng-container>
                                <ng-container *ngIf="flowType?.type==switchType">
                                    {{'popupMessages.referralBody5Switch'|translate}}
                                </ng-container>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="maObjPresent">
                            <ng-container *ngIf="isReferralMaPresent">
                                <div class="row no-gutters px-3  pb-3">
                                    <div class="col-md-5 breaker pr-3">
                                        <p class="sectionHeading_two m-0">{{maObj.firstname}}</p>
                                        <p>{{'popupMessages.cibcMa'|translate}}</p>
                                    </div>
                                    <div class="col-md-7 pl-md-4 pt-2">
                                        <div class="pb-3">
                                            <img class="pr-2" aria-hidden="true" src="./assets/icons/Mobile.svg"
                                                alt="helpIcon-icon" role="dialog">
                                            <a [href]="'tel:'+maObj?.phone_number" tabindex="0">
                                                <span class="note_link">
                                                    <u>{{maObj?.phone_number | mask: '000-000-0000'}}</u>
                                                </span>
                                                <span class="show-for-sr">{{'header.txtPhn' |translate}}</span>
                                            </a>
                                        </div>
                                        <div class="mb-3">
                                            <img class="pr-2" aria-hidden="true" src="./assets/icons/Mail.svg"
                                                alt="helpIcon-icon" role="dialog">
                                            <u>
                                                {{maObj?.email}}
                                                <span class="show-for-sr">{{'summarypage.tootipEmail'
                                                    |translate}}</span>
                                            </u>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isReferralMaPresent">
                                <p>{{'popupMessages.referralWithNoMa'|translate}}</p>
                                <span>{{'popupMessages.referralWithNoMa2'|translate}}<a [href]="referralLink"
                                        target="_blank" class="note_link"
                                        (click)="closeGeneric()"><u>{{'popupMessages.referralBody4New'|translate}}</u></a>
                                    <ng-container *ngIf="flowType?.type==prequalType">
                                        {{'popupMessages.referralWithNoMa3'|translate}}
                                    </ng-container>
                                    <ng-container *ngIf="flowType?.type==switchType">
                                        {{'popupMessages.referralWithNoMa3Switch'|translate}}
                                    </ng-container>
                                </span>
                            </ng-container>
                        </ng-container>
                        <div *ngIf="!maObjPresent||!isReferralMaPresent">
                            <div class="row no-gutters rowStyle">
                                <div [ngClass]="currentLang=='fr'?'col-12':'col-12 d-md-none'">
                                    <a class="referral" [href]="referralLink">
                                        <button type="button "
                                            class="w-100 saveNextBtn_features buttonstyle">{{'popupMessages.findMortgageAdvisor'|translate}}</button>
                                    </a>
                                </div>
                                <div [ngClass]="currentLang=='fr'?'col-12':'col-md-6 col-12 pr-md-2'">
                                    <button type="button " class="w-100 cancelBtn_features buttonstyle"
                                        (click)="closePopup()">{{'popupMessages.cancelBtn'|translate}}</button>
                                </div>
                                <div [ngClass]="currentLang=='fr'?'d-none':'col-md-6 col-12 pl-2 d-md-block d-none'">
                                    <button type="button " (click)="findAdvisor()"
                                        class="w-100 saveNextBtn_features buttonstyle">{{'popupMessages.findMortgageAdvisor'|translate}}</button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="row no-gutters" role="banner">
        <div class="col-6">
            <a id="logoId" [href]="cibcWebsiteLink">
                <img class="logoImg" src="../../../assets/icons/NewIcons/CIBC_logo_Small.svg"
                    alt="CIBC Personal Banking">
            </a>
        </div>
        <div class="col-6 d-flex flex-column  align-items-end font-size-18 headingContent">
            <span class="d-md-block d-none">
                <ng-container *ngIf="flowType?.type==prequalType">
                    {{'header.title' | translate}}
                </ng-container><ng-container *ngIf="flowType?.type==switchType">
                    {{'header.title_switch' | translate}}
                </ng-container>
            </span>
            <span class="d-md-block d-none">{{'header.contactUsReferral' |translate}}
                <button class="infoButton p-0" (click)="openContactPopup()" type="button" tabindex="0" id="contactus">
                    <span class="note_link">
                        <u>{{'header.contactReferral'|translate}}</u>
                    </span>
                </button>
            </span>
            <span class="d-md-none d-block note_link" (click)="openContactPopup()" tabindex="0" role="button">
                <u>{{'header.contactReferral'|translate}}</u>
            </span>
        </div>
    </div>
</div>